"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateIssueTemplateByIdAction = exports.reducer = exports.getIssueTemplatesState = exports.getIssueTemplatesEntitiesMap = exports.getIsTemplateStatusActive = exports.getIsLoadingTemplates = exports.getFnForIsTemplateActive = exports.getFnForGetIssueTemplateById = exports.getAllTemplatesSortedByTitle = exports.getAllTemplates = exports.getActiveTemplateOptionsGroupedByType = exports.fetchIssueTemplatesAction = exports.deleteIssueTemplateByIdAction = exports.STATE_KEY = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _sortingHelpers = require("../../../utils/data/sortingHelpers");
var _fetchHelpers = require("../fetchHelpers");
var _issueTypes = require("./issueTypes");
var _currentUserPermissions = require("./currentUserPermissions");
const initialState = {
  [_fetchHelpers.STATUS_KEY]: _fetchHelpers.FetchStatus.Initial,
  entitiesMap: {},
  pendingUpdatesMap: {}
};
const issueTemplatesSlice = (0, _toolkit.createSlice)({
  name: "issueTemplates",
  initialState,
  reducers: {
    issueTemplatesFetchStart(state) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Loading;
    },
    issueTemplatesFetchSuccess(state, action) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Success;
      state.entitiesMap = {};
      action.payload.forEach(template => {
        state.entitiesMap[template.id] = template;
      });
      state.pendingUpdatesMap = {};
    },
    issueTemplateUpdateByIdStart: (state, action) => {
      state.pendingUpdatesMap = {
        ...state.pendingUpdatesMap,
        [action.payload.id]: action.payload.templateData
      };
    },
    issueTemplateUpdateByIdFailure: (state, action) => {
      delete state.pendingUpdatesMap[action.payload.id];
    },
    issueTemplateDeleteByIdSuccess: (state, action) => {
      delete state.entitiesMap[action.payload.id];
      delete state.pendingUpdatesMap[action.payload.id];
    }
  }
});
const {
  issueTemplatesFetchStart,
  issueTemplatesFetchSuccess,
  issueTemplateUpdateByIdStart,
  issueTemplateUpdateByIdFailure,
  issueTemplateDeleteByIdSuccess
} = issueTemplatesSlice.actions;
const reducer = exports.reducer = issueTemplatesSlice.reducer;
const STATE_KEY = exports.STATE_KEY = issueTemplatesSlice.name;
const getIssueTemplatesState = state => {
  return state[STATE_KEY];
};
exports.getIssueTemplatesState = getIssueTemplatesState;
const getIsLoadingTemplates = exports.getIsLoadingTemplates = (0, _toolkit.createSelector)(getIssueTemplatesState, _fetchHelpers.isLoading);
const mergeIssueTemplatePendingUpdates = _ref => {
  let {
    issueTemplate,
    issueTemplatePendingUpdates
  } = _ref;
  // we do a simple merge, because for now we have to send
  // all the template data in order to update one field in issueAttributes
  // on a template... this has disadvantages, but it does mean that it's easy to determine
  // what the template should be based on its pending data!
  return {
    ...issueTemplate,
    ...issueTemplatePendingUpdates
  };
};

// getIssueTypeEntitiesMap will include any optimistic updates
const getIssueTemplatesEntitiesMap = exports.getIssueTemplatesEntitiesMap = (0, _toolkit.createSelector)(getIssueTemplatesState, issueTemplatesState => {
  const entitiesMap = {
    ...issueTemplatesState.entitiesMap
  };
  Object.keys(issueTemplatesState.pendingUpdatesMap).forEach(entityId => {
    entitiesMap[entityId] = mergeIssueTemplatePendingUpdates({
      issueTemplate: {
        ...entitiesMap[entityId]
      },
      issueTemplatePendingUpdates: issueTemplatesState.pendingUpdatesMap[entityId]
    });
  });
  return entitiesMap;
});
const getAllTemplates = exports.getAllTemplates = (0, _toolkit.createSelector)(getIssueTemplatesEntitiesMap, templatesMap => {
  return Object.values(templatesMap);
});
const getAllTemplatesSortedByTitle = exports.getAllTemplatesSortedByTitle = (0, _toolkit.createSelector)(getIssueTemplatesEntitiesMap, templatesMap => {
  return Object.values(templatesMap).sort((templateA, templateB) => {
    return (0, _sortingHelpers.localeCompareByTitle)(templateA.issueAttributes, templateB.issueAttributes);
  });
});
const getFnForGetIssueTemplateById = exports.getFnForGetIssueTemplateById = (0, _toolkit.createSelector)(getIssueTemplatesEntitiesMap, issueTemplatesEntitiesMap => {
  const getIssueTemplateById = issueTemplateId => {
    if (!issueTemplateId) {
      return undefined;
    }
    const issueTemplate = issueTemplatesEntitiesMap[issueTemplateId];
    if (!issueTemplate) {
      return undefined;
    }
    return issueTemplate;
  };
  return getIssueTemplateById;
});
const getFnForIsTemplateActive = exports.getFnForIsTemplateActive = (0, _toolkit.createSelector)(_issueTypes.getIssueTypeEntitiesMap, issueTypeEntities => {
  const getIsTemplateActive = template => {
    if (!template.isActive) {
      return false;
    }
    const typeId = template.issueAttributes.typeId;
    const type = issueTypeEntities[typeId];
    if (!type) {
      return false;
    }
    if (!type.isActive) {
      return false;
    }
    const category = issueTypeEntities[type.issueTypeCategoryId];
    if (!category) {
      return false;
    }
    return true;
  };
  return getIsTemplateActive;
});
const getIsTemplateStatusActive = _ref2 => {
  let {
    template,
    currentUserPermittedStatusesForNewIssue
  } = _ref2;
  if (template.issueAttributes.status && !currentUserPermittedStatusesForNewIssue.includes(template.issueAttributes.status)) {
    return false;
  }
  return true;
};
exports.getIsTemplateStatusActive = getIsTemplateStatusActive;
const getActiveTemplateOptionsGroupedByType = exports.getActiveTemplateOptionsGroupedByType = (0, _toolkit.createSelector)(getAllTemplatesSortedByTitle, _issueTypes.getIssueTypeEntitiesMap, _currentUserPermissions.getCurrentUserPermittedStatusesForNewIssue, (allTemplates, issueTypeEntities, currentUserPermittedStatusesForNewIssue) => {
  const typeIdsToTemplates = {};
  allTemplates.forEach(template => {
    if (!template.isActive) {
      return;
    }
    const isTemplateStatusActive = getIsTemplateStatusActive({
      template,
      currentUserPermittedStatusesForNewIssue
    });
    if (!isTemplateStatusActive) {
      return;
    }
    const templateOption = {
      label: template.issueAttributes.title,
      value: template.id
    };
    if (typeIdsToTemplates[template.issueAttributes.typeId]) {
      typeIdsToTemplates[template.issueAttributes.typeId].push(templateOption);
    } else {
      typeIdsToTemplates[template.issueAttributes.typeId] = [templateOption];
    }
  });
  const optionGroups = [];
  Object.keys(typeIdsToTemplates).forEach(typeId => {
    const type = issueTypeEntities[typeId];
    if (!type) {
      console.warn("type for issue templates could not be found:", typeId);
      return;
    }
    if (!type.isActive) {
      console.warn("type for issue templates could is not active:", typeId, type.title);
      return;
    }
    const category = issueTypeEntities[type.issueTypeCategoryId];
    if (!category) {
      console.warn("category for type could not be found:", category);
      return;
    }
    optionGroups.push({
      label: "".concat(category.title, " > ").concat(type.title),
      options: typeIdsToTemplates[typeId],
      typeId,
      items: typeIdsToTemplates[typeId]
    });
  });
  optionGroups.sort((a, b) => {
    return a.label.localeCompare(b.label);
  });
  return optionGroups;
});
const fetchIssueTemplatesAction = () => async (dispatch, getState, _ref3) => {
  let {
    sdk
  } = _ref3;
  dispatch(issueTemplatesFetchStart());
  const payload = await sdk.IssueTemplates.getAll();
  if (payload.results) {
    dispatch(issueTemplatesFetchSuccess(payload.results));
  }
  // currently no action is taken if a fetch fails for some reason.
  // maybe this is a TODO??
};
exports.fetchIssueTemplatesAction = fetchIssueTemplatesAction;
const updateIssueTemplateByIdAction = _ref4 => {
  let {
    id,
    newTemplateData,
    onFailure,
    onSuccess
  } = _ref4;
  return async (dispatch, getState, _ref5) => {
    let {
      sdk
    } = _ref5;
    dispatch(issueTemplateUpdateByIdStart({
      id,
      templateData: newTemplateData
    }));
    try {
      await sdk.IssueTemplates.update(id, newTemplateData);
    } catch (error) {
      console.error("sdk.IssueTemplates.update error:", error);
      dispatch(issueTemplateUpdateByIdFailure({
        id
      }));
      onFailure && onFailure();
      return;
    }
    onSuccess && onSuccess();
    dispatch(fetchIssueTemplatesAction());
  };
};
exports.updateIssueTemplateByIdAction = updateIssueTemplateByIdAction;
const deleteIssueTemplateByIdAction = _ref6 => {
  let {
    id,
    onSuccess,
    onFailure
  } = _ref6;
  return async (dispatch, getState, _ref7) => {
    let {
      sdk
    } = _ref7;
    try {
      await sdk.IssueTemplates.delete(id);
    } catch (error) {
      console.error("sdk.IssueTemplates.delete error:", error);
      onFailure && onFailure();
      return;
    }
    issueTemplateDeleteByIdSuccess({
      id
    });
    onSuccess && onSuccess();
    dispatch(fetchIssueTemplatesAction());
  };
};
exports.deleteIssueTemplateByIdAction = deleteIssueTemplateByIdAction;
//# sourceMappingURL=issueTemplates.js.map